import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ChatPanel } from '../../../panels/chatPanel/chatPanel';
import { mttStagingChatInputHandler } from '../../../utils/messageInputUtils';
export const MttStagingChatPanel = () => {
    return _jsx(ChatPanel, { messageInputHandler: mttStagingChatInputHandler });
};
